import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { findPublicRoute } from "../seo/publicRoutes";
import { MARKETING_CONSENT_EVENT, isMetaPixelActive, trackMetaEvent } from "../lib/metaPixel";

/** Public pages plus signup: the audiences the ads retarget. App screens are left out. */
const tracksMetaPageView = (pathname: string) =>
  Boolean(findPublicRoute(pathname)) || pathname.replace(/\/+$/, "") === "/signup";

/**
 * One Meta PageView per public route change, and one when consent arrives
 * mid-visit. Also counts clicks on sales mailto links ("Demo iste" in the
 * header, landing sections, footer) as Lead: a demo request is an e-mail,
 * so the click is the only signal there is.
 */
export function MetaPixelPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const link = (event.target as Element | null)?.closest?.('a[href^="mailto:info@meethumo.com"]');
      // Label kept from the sales@ days so existing ad conversions keep matching.
      if (link) trackMetaEvent("Lead", { content_name: "sales_mailto" });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (isMetaPixelActive() && tracksMetaPageView(pathname)) trackMetaEvent("PageView");

    const onConsent = () => {
      if (tracksMetaPageView(window.location.pathname)) trackMetaEvent("PageView");
    };
    window.addEventListener(MARKETING_CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(MARKETING_CONSENT_EVENT, onConsent);
  }, [pathname]);

  return null;
}
